
import { properties } from '../../pages/pageAltaUsuario/pageAltaUsuarioData';
import RestProvider from 'providers/RestProvider';
import { getUrl } from 'config/Config';
import { useSelector } from 'react-redux';

const FormioFunctions = () => {

    const { crudOperation, crudOperationsType } = RestProvider();

    const infoUsuario = useSelector((state) => state.kingdomOV3.infoUsuario);
    const convocatoriaSeleccionada = useSelector((state) => state.kingdomOV3.convocatoriaSeleccionada);
    const perfilSeleccionado = useSelector((state) => state.kingdomOV3.perfilSeleccionado);
    const organismo = useSelector((state) => state.kingdomOV3.organismo);
    const modBajaRADA = useSelector((state) => state.kingdomOV3.modBajaRADA);

    /**Devuelve una lista de provincias*/
    const getProvincias = async () => {
        let res = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MANAGER, { url: properties.URL_GET_PROVINCIAS, method: 'get' }).then(response => {
        res = response.data;
        }).catch(function (error) {
        
        })      

        return res;
    }
    const getProvinciasDescripcion = async (codigoProvincia) => {
        let res = null;
        let resultado = null;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MANAGER, { url: properties.URL_GET_PROVINCIAS, method: 'get' }).then(response => {
        res = response.data;
        }).catch(function (error) {
        })
        for (const element of res) {
            if(element.codigo==codigoProvincia){
                resultado = element.descripcionLarga;
            }
        }
        return resultado;
    }


    /**Devuelve una lista de municipios de la provincia correspondiente al codProvincia*/
    const getMunicipios = async (codProvincia) => {
        let res = null;
        let completeUrl = properties.URL_GET_MUNICIPIOS.concat(codProvincia);
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MANAGER, { url: completeUrl, method: 'get' }).then(response => {
        res = response.data;
        });

        return res;
    }

    /**Devuelve una lista de tipos de vía*/
    const getTipoVias = async () => {
        let res = null;

        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MANAGER, { url: properties.URL_GET_TIPO_VIAS, method: 'get' }).then(response => {
            res = response.data;
        });

        return res;
    }

    /**Devuelve una lista de paises*/
    const getPaises = async () => {
        let res = null;

    await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MANAGER, { url: properties.URL_GET_PAISES, method: 'get' }).then(response => {
            res = response.data;
    });

        return res;
    }

    /**Devuelve una lista de organismos*/
    const getOrganismos = async () => {
        let res = null;
        await crudOperation(crudOperationsType.CUSTOM, properties.RESOURCE_MOTOR_TRAMITACION, { url: properties.URL_ORGANISMOS + '/' + convocatoriaSeleccionada.id, method: 'get' }).then(response => {
        res = response.data;
        }).catch(function (error) {
        
        })      

        return res;
    }

    /**
     * Calcula el valor del check de "Actuo en calidad de: " existente en el bloque de datos Personales
     * @returns 
     */
     const calculaActuaEnCalidadDe = async () => {
        let res = null;
        
        if (infoUsuario !== null && infoUsuario.entidadCif !== null){
            
            res = "representanteDeEntidadUOtraPersona";
        }else{
            res="auxiliar"
        }
        
        return res;
    }

    /**
     * Obtiene el valor de la información del usuario almacenada en sesión
     * @param {*} campo 
     * @returns 
     */
    const obtenerValoresUsuario = async (campo) => {

        let personaJuridica = infoUsuario != null && infoUsuario.entidadNombre != null;

        let res = null;
        
        switch (campo) {
            case "entidadCif": res = personaJuridica ? infoUsuario.entidadCif : "";
                break;
            case "entidadNombre": res = personaJuridica ? infoUsuario.entidadNombre : "";
                break;
            case "interesadoNombre": res = infoUsuario.interesadoNombre
                break;
            case "interesadoApellido1": res = infoUsuario.interesadoApellido1
                break;
            case "interesadoApellido2": res = infoUsuario.interesadoApellido2
                break;
            case "interesadoNif": res = infoUsuario.interesadoNif
                break;
            case "personaFisicaJuridica": res = personaJuridica ? "juridica" : "fisica";
                break;
            default: res = "";
                break;
        }
        return res;
    }

    /**
     * Obtiene el valor de la información del usuario almacenada en sesión
     * @param {*} campo 
     * @returns 
     */
     const obtenerUrlContexto = async () => {
        let url = getUrl();
        return url;
    }

    /**
     * Obtiene la convocatoria en la que nos encontramos
     * @returns 
     */
     const obtenerConvocatoria = async () => {
        return convocatoriaSeleccionada;    
    }

    /** Obtiene el perfil seleccionado para la convocatoria actual
     * @returns
    */
    const obtenerPerfilSeleccionado = async () => {
        let res = perfilSeleccionado !== '' ? JSON.stringify(perfilSeleccionado) : perfilSeleccionado;
        return res;
    }

    /**
     * Obtiene el organismo seleccionado
     * @returns 
     */
    const obtenerOrganismo = async () => {
        let res = organismo.dir3 !== '' ? JSON.stringify(organismo) : organismo;
        return res;
    }

    /** Obtiene el perfil seleccionado para la convocatoria actual
     * @returns
     */
        const obtenerModBajaRADA = async () => {
            let res = modBajaRADA !== '' ? JSON.stringify(modBajaRADA) : modBajaRADA;
            return res;
        }

    return { getProvincias, getProvinciasDescripcion, getMunicipios, getTipoVias, getPaises, getOrganismos, calculaActuaEnCalidadDe,
        obtenerValoresUsuario, obtenerUrlContexto, obtenerConvocatoria, obtenerPerfilSeleccionado, obtenerOrganismo, obtenerModBajaRADA };
}

export default FormioFunctions;